// extracted by mini-css-extract-plugin
module.exports = {"user-menu":"style_user-menu__U0qVb","menu":"style_menu__1phas","account":"style_account__1W6lr","user-name":"style_user-name__2Bafj","avatar":"style_avatar__lireG"};